import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getAProduct } from "../features/product/productSlice";
import { BiArrowBack } from "react-icons/bi";
import { Table } from "antd";
import { resolveMediaUrl } from "../utils/mediaUrl";

const ViewProduct = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const getProductId = location.pathname.split("/")[3];
  const productState = useSelector((state) => state.product);
  console.log("Product", productState);
  const { id, averageRating, productName, promoType, price, aboutProduct, status, metalName, gender, weight, height, width, gross_weight, net_weight, pcs, size, makingCharge, makingType, designCode, productImages, discountType, discount, productPurity, colorName } = productState;

  // useEffect(() => {
  //   dispatch(getAProduct(getProductId));
  // }, [getProductId]);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     setLoading(true);
  //     await dispatch(getAProduct(getProductId));
  //     setLoading(false);
  //   };
  //   fetchData();
  // }, [getProductId, dispatch]);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        setLoading(true);
        await dispatch(getAProduct(getProductId));
        setLoading(false);
      } catch (error) {
        console.error("Error fetching product:", error);
        setLoading(false);
      }
    };

    fetchProduct();

    return () => {
      // Cleanup if needed
    };
  }, [getProductId, dispatch]);

  const goBack = () => {
    navigate(-1);
  };

  const { isError } = useSelector((state) => state.product);

  if (isError) {
    return (
      <div className="alert alert-danger">
        Failed to load product details. Please try again.
        <button onClick={() => window.location.reload()} className="btn btn-link">
          Retry
        </button>
      </div>
    );
  }

  const columns = [
    {
      title: "Field",
      dataIndex: "field",
      key: "field",
    },
    {
      title: "Value",
      dataIndex: "value",
      key: "value",
      render: (text, record) => {
        if (record.field === "Product Images") {
          return (
            <div>
              {Array.isArray(text) ? text.map((img, index) => (
                <img key={index} src={resolveMediaUrl(img)} alt={`Product ${index}`} width={100} height={100} style={{ marginRight: 10 }} />
              )) : <img src={resolveMediaUrl(text)} alt="Product" width={100} height={100} />}
            </div>
          );
        }
        return text;
      },
    },
  ];

  const data = [
    { key: "1", field: "Product ID", value: id },
    { key: "2", field: "Average Ratings", value: averageRating },
    { key: "3", field: "Product Name", value: productName },
    { key: "4", field: "Price", value: price },
    // { key: "5", field: "About This Item", value: aboutProduct.replace(/<\/?[^>]+(>|$)/g, "") },
    { key: "6", field: "Status", value: status },
    { key: "7", field: "Metal Name", value: metalName },
    { key: "8", field: "Gender", value: gender },
    { key: "9", field: "Weight (gms)", value: weight },
    { key: "10", field: "Height", value: height },
    { key: "11", field: "Width", value: width },
    { key: "12", field: "Gross Weight (gms)", value: gross_weight },
    { key: "13", field: "Net Weight (gms)", value: net_weight },
    { key: "14", field: "Pcs", value: pcs },
    { key: "16", field: "Size", value: size },
    { key: "18", field: "Making Charges Per Gram", value: makingCharge },
    { key: "19", field: "Making Type", value: makingType },
    { key: "20", field: "Design Code", value: designCode },
    { key: "21", field: "Product Images", value: productImages },
    { key: "22", field: "Discount Type", value: discountType },
    { key: "23", field: "Discount", value: discount },
    { key: "24", field: "Product Purity", value: productPurity },
    { key: "25", field: "Promotional Type", value: promoType },
  ];

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "50vh" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center">
        <h3 className="mb-4 title">View Product Details</h3>
        <button
          className="bg-transparent border-0 fs-6 mb-0 d-flex align-items-center gap-1"
          onClick={goBack}
        >
          <BiArrowBack className="fs-5" /> Go Back
        </button>
      </div>

      <div className="mt-5 bg-white p-4 rounded-3">
        <Table columns={columns} dataSource={data} pagination={false} />
      </div>
    </div>
  );
};

export default ViewProduct;